import React from "react";

const Miniloader = (props) => {
    return (
        <div className="flex flex-row gap-2">
            <div className={`w-4 h-4 rounded-full ${props.invert ? 'bg-black/35' : 'bg-white/65'} animate-bounce`}></div>
            <div className={`w-4 h-4 rounded-full ${props.invert ? 'bg-black/20' : 'bg-white/50'} animate-bounce [animation-delay:-.3s]`}></div>
            <div className={`w-4 h-4 rounded-full ${props.invert ? 'bg-black/15' : 'bg-white/35'} animate-bounce [animation-delay:-.5s]`}></div>
        </div>
    );
}

export { Miniloader };